export const extractFeatures = (companyFeatures) => companyFeatures.map(({ id }) => id);
export const extractFileSystemFeatures = (fileSystemCompanyFeatures) => fileSystemCompanyFeatures.map(({ feature }) => feature.toLocaleLowerCase());
export const extractMetadataFeature = (features) => features.map(({ feature }) => feature);
